
import { useState, useEffect } from "react";

export type ConnectionStatus = "all" | "online" | "offline";
export type PlanFilter = "all" | "free" | "basic" | "pro" | "premium";
export type ChatAccessFilter = "all" | "approved" | "blocked";

export const useAdminPanelState = (users: any[]) => {
  const [filteredUsers, setFilteredUsers] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [connectionFilter, setConnectionFilter] = useState<ConnectionStatus>("all");
  const [planFilter, setPlanFilter] = useState<PlanFilter>("all");
  const [chatAccessFilter, setChatAccessFilter] = useState<ChatAccessFilter>("all");

  useEffect(() => {
    if (users.length > 0) {
      filterUsers();
    }
  }, [searchQuery, users, connectionFilter, planFilter, chatAccessFilter]);

  const filterUsers = () => {
    let filtered = [...users];

    // Filtro de busca por texto
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase().trim();
      filtered = filtered.filter(user => {
        const name = (user.display_name || "").toLowerCase();
        const email = (user.email || "").toLowerCase();
        return name.includes(query) || email.includes(query);
      });
    }

    // Filtro de status de conexão
    if (connectionFilter !== "all") {
      filtered = filtered.filter(user => {
        const lastActiveDate = user.last_access ? new Date(user.last_access) : null;
        const now = new Date();
        const isOnline = lastActiveDate ? (now.getTime() - lastActiveDate.getTime()) < (2 * 60 * 1000) : false;
        
        return connectionFilter === "online" ? isOnline : !isOnline;
      });
    }

    // Filtro de plano
    if (planFilter !== "all") {
      filtered = filtered.filter(user => {
        const userPlan = (user.plan || "free").toLowerCase();
        return userPlan === planFilter;
      });
    }

    // Filtro de acesso ao chat
    if (chatAccessFilter !== "all") {
      filtered = filtered.filter(user => {
        const hasAccess = user.status_chat === true;
        return chatAccessFilter === "approved" ? hasAccess : !hasAccess;
      });
    }

    setFilteredUsers(filtered);
  };

  return {
    filteredUsers,
    searchQuery,
    setSearchQuery,
    connectionFilter,
    setConnectionFilter,
    planFilter,
    setPlanFilter,
    chatAccessFilter,
    setChatAccessFilter
  };
};
